import _upperFirst from 'lodash/upperFirst';

const capitalize = (str = '') => {
  return str.replace(/\w+/g, _upperFirst);
};

export default capitalize;
